export default __webpack_public_path__ + "static/media/TouchBook.0a0a86bdfb221b84d7e0dbc1eb90dd26.webp";